import { Step } from 'signup-constants/Step';
import { LoadingKey } from '../../app-active-loading/LoadingKey';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getWhichOAuthSelected } from '../../store/app/selectors';
import { getIsAuthenticated } from '../../store/auth/selectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Tracker } from '../../store/tracking/action-creators';
import { ExperimentKeys } from '../ExperimentKeys';
import { ExperimentParameterGroup } from '../ExperimentParameterGroup';
import { NextStepManager } from '../../flow-management/NextStepManager';
import { shouldSkipHublet } from '../../hublets/hubletUtils';
const ACQ149MappedLoadingKeys = new Map([[LoadingKey.SignupRequest, LoadingKey.ACQ149SignupRequest], [LoadingKey.LoginAfterSignup, LoadingKey.ACQ149PortalCreated]]);
export const getACQ149EndpointLoadingKey = (state, loadingKey) => {
  const parameter = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0149, [ExperimentParameterGroup.Variant_A]);
  if (parameter && loadingKey && ACQ149MappedLoadingKeys.has(loadingKey)) return ACQ149MappedLoadingKeys.get(loadingKey);
  return loadingKey;
};
export const setFlowForACQ149 = ({
  stepsToRemove = [],
  isPreVerificationExistingUserSession = false
}) => dispatch => {
  const {
    postExistingAccountSelection: acq149VariantAPostExistingAccountSelectionSteps,
    postAccountCreation,
    preVerification
  } = getFlowSteps();
  const maybeAddHubletSelection = shouldSkipHublet() ? [] : [Step.HubletSelection];
  const acq149VariantAPostVerificationSteps = [Step.Password, Step.Name, Step.Industry, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, ...maybeAddHubletSelection];
  const acq149NextSteps = [...(isPreVerificationExistingUserSession ? [Step.ExistingUser] : []), ...(isPreVerification() ? preVerification : []), ...acq149VariantAPostVerificationSteps, ...postAccountCreation];
  const acq149FlowSteps = {
    acq149NextSteps,
    preVerification,
    acq149VariantAPostVerificationSteps,
    postAccountCreation,
    acq149VariantAPostExistingAccountSelectionSteps
  };
  if (stepsToRemove.length > 0) {
    // replicating the logic inside FlowStateManager.removeSteps(stepsToRemove)
    Object.keys(acq149FlowSteps).forEach(key => {
      acq149FlowSteps[key] = NextStepManager.removeSteps(...stepsToRemove)(acq149FlowSteps[key]);
    });
  }
  dispatch(setFlow(acq149FlowSteps.acq149NextSteps, acq149FlowSteps.preVerification, acq149FlowSteps.acq149VariantAPostVerificationSteps, acq149FlowSteps.postAccountCreation, acq149FlowSteps.acq149VariantAPostExistingAccountSelectionSteps));
  return acq149NextSteps;
};
export const setupAuthForOAuthExistingUserACQ149 = (state, experimentKey, dispatch) => {
  const oAuthProviderSelected = getWhichOAuthSelected(state);
  dispatch(Tracker.signupInteraction(`${experimentKey}-${oAuthProviderSelected}-oauth-existing-user-variant_a`));
  dispatch(setFlowForACQ149({
    isPreVerificationExistingUserSession: getIsAuthenticated(state) && isPreVerification()
  }));
};